export default "__VITE_ASSET__50bd3203__"